module.exports = __webpack_public_path__ + "img/home-bg2.f6174a27.png";